<template>
  <SimpleStackedChart
    :name="$t('Chart__NumberOfContEducation__name')"
    :sheets="sheets"
  >
    <p class="fmhind-graph-number-of-cont-education__source">
      {{ $t('Chart__NumberOfContEducation__source') }}
    </p>
  </SimpleStackedChart>
</template>

<script>
import data from '@/assets/json/NumberOfContEducation.json';
import SimpleStackedChart from '@/components/ChartPartials/SimpleStackedChart';

export default {
  name: 'NumberOfContEducation',
  components: {
    SimpleStackedChart
  },
  data() {
    return {
      sheets: data
    };
  }
};
</script>

<style lang="scss">
.fmhind-graph-number-of-cont-education__source {
  @extend %chart-source;
}
</style>
